import React, { useId } from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

/* ------------------------------------------------------------------ */
/* Halloween: lysande pumpa                                             */
/* ------------------------------------------------------------------ */
export const PumpkinIcon: React.FC<IconProps & { face?: boolean }> = ({ face = true, ...props }) => {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <filter id={`glow-${id}`} x="-40%" y="-40%" width="180%" height="180%">
          <feGaussianBlur stdDeviation="2.2" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {/* Stjälk och slinga */}
      <path d="M48 22 C 46 13, 52 8, 59 9 C 56 13, 55 18, 56 24 Z" fill="#65a30d" />
      <path d="M57 12 C 64 8, 70 12, 68 18" fill="none" stroke="#65a30d" strokeWidth="2" strokeLinecap="round" />
      {/* Kropp i segment */}
      <ellipse cx="50" cy="60" rx="42" ry="35" fill="#c2410c" />
      <ellipse cx="27" cy="60" rx="17" ry="33" fill="#ea580c" />
      <ellipse cx="73" cy="60" rx="17" ry="33" fill="#ea580c" />
      <ellipse cx="50" cy="60" rx="18" ry="36" fill="#f97316" />
      <path d="M32 27 C 28 45, 28 75, 34 92" fill="none" stroke="#9a3412" strokeWidth="1.5" opacity="0.5" />
      <path d="M68 27 C 72 45, 72 75, 66 92" fill="none" stroke="#9a3412" strokeWidth="1.5" opacity="0.5" />
      <ellipse cx="38" cy="36" rx="7" ry="4" fill="#ffffff" opacity="0.22" transform="rotate(-20 38 36)" />
      {face && (
        <g fill="#fde047" filter={`url(#glow-${id})`}>
          <path d="M25 58 L36 42 L45 58 Z" />
          <path d="M55 58 L64 42 L75 58 Z" />
          <path d="M46 68 L50 61 L54 68 Z" />
          <path d="M22 72 L30 80 L37 73 L43 82 L50 75 L57 82 L63 73 L70 80 L78 72 C 70 92, 30 92, 22 72 Z" />
        </g>
      )}
    </svg>
  );
};
